/* Radivaria — dependency-free interactions.
   Scroll reveal, sticky-header state, side drawer, product gallery. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Scroll reveal ---------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Header: hairline + shadow once the page has moved ---------------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var stuck = false;
    function onScroll() {
      var past = window.scrollY > 8;
      if (past !== stuck) {
        stuck = past;
        header.classList.toggle('is-stuck', past);
      }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Side drawer ------------------------------------------------------ */
  function initDrawer() {
    var toggle = document.querySelector('[data-drawer-open]');
    var drawer = document.getElementById('NavDrawer');
    var scrim = document.querySelector('[data-drawer-scrim]');
    if (!toggle || !drawer) return;
    var closeEls = drawer.querySelectorAll('[data-drawer-close]');

    function open() {
      drawer.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }

    toggle.addEventListener('click', open);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---- Product gallery: thumbnail swap ---------------------------------- */
  function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        if (!src) return;
        // srcset wins over src, so it must be swapped too (or the image never changes)
        main.srcset = thumb.getAttribute('data-srcset') || '';
        main.src = src;
        main.alt = thumb.getAttribute('data-alt') || main.alt;
        thumbs.forEach(function (other) {
          other.classList.toggle('is-active', other === thumb);
          other.setAttribute('aria-current', other === thumb ? 'true' : 'false');
        });
      });
    });
  }

  /* ---- Ticker: only animate when the copy is wider than the viewport ----- */
  function initTicker() {
    var track = document.querySelector('[data-ticker-track]');
    if (!track || reduceMotion) return;
    var groups = track.querySelectorAll('.ticker__group');
    if (!groups.length) return;
    // A single group narrower than the viewport would scroll into a visible gap,
    // so centre one copy and drop the duplicate instead of animating.
    if (groups[0].offsetWidth < window.innerWidth) {
      track.style.animation = 'none';
      track.style.justifyContent = 'center';
      track.style.width = '100%';
      if (groups[1]) groups[1].style.display = 'none';
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initReveal();
    initHeader();
    initDrawer();
    initGallery();
    initTicker();
  });
}());
